import React from 'react';
import { useField } from 'formik';
import { normalizePhoneNumberNoPlaceholder } from 'ui-toolkit/utilities/normalizePhoneNumber';
import { TextInputTW, TextInputTWProps } from 'tailwindComponents/textInputTW/TextInputTW';
import { useErrorText } from 'tailwindComponents/hooks/useErrorText';

export interface PhoneNumberFieldTWProps extends TextInputTWProps {
  name: string;
}

export const PhoneNumberFieldTW: React.FC<PhoneNumberFieldTWProps> = ({ name, value, onChange, ...rest }) => {
  const [fieldInputProps, fieldMetaProps] = useField<string>(name);
  const errorText = useErrorText<string>(fieldMetaProps);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (value) {
      e.target.value = normalizePhoneNumberNoPlaceholder(value);
    }

    fieldInputProps.onChange(e);
  };

  const props = {
    ...fieldInputProps,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)
  };

  return <TextInputTW errorText={errorText} type={'tel'} placeholder={'(###) ###-####'} {...rest} {...props}  />;
};
